var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Box, useRecipe } from "@chakra-ui/react";
export var JobBadges = function (_a) {
    var job = _a.job;
    var recipe = useRecipe({ key: "JobBadges" });
    var styles = recipe();
    if (job.salary === undefined && job.type === undefined) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs(Box, __assign({ css: styles }, { children: [job.salary && _jsx(Badge, __assign({ variant: "job" }, { children: job.salary })), job.type && _jsx(Badge, __assign({ variant: "job" }, { children: job.type }))] })));
};
